import { render, staticRenderFns } from "./partenr-income.vue?vue&type=template&id=fdabee02&scoped=true&"
import script from "./partenr-income.vue?vue&type=script&lang=js&"
export * from "./partenr-income.vue?vue&type=script&lang=js&"
import style0 from "./partenr-income.vue?vue&type=style&index=0&id=fdabee02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdabee02",
  null
  
)

export default component.exports